import { create } from 'zustand';

interface DashboardStore {
  defaultDashboard: string | null;
  setDefaultDashboard: (dashboard: string) => void;
  resetDashboardStore: () => void;
}

const useDashboardStore = create<DashboardStore>((set) => ({
  defaultDashboard: null,
  setDefaultDashboard: (dashboard) => set({ defaultDashboard: dashboard }),
  resetDashboardStore: () => set({ defaultDashboard: null }),
}));

export default useDashboardStore;
